import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { provideTransloco, translocoConfig, TranslocoLoader } from "@ngneat/transloco";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get(`/assets/i18n/${lang}.json`);
  }
}

export const provideTranslocoConfig = provideTransloco({
  config: translocoConfig({
    availableLangs: environment.availableLangs,
    defaultLang: environment.dfConfigLang || 'es',
    fallbackLang  : environment.dfConfigLang || 'es',
    reRenderOnLangChange: true,
    prodMode: environment.production,
  }),
  loader: TranslocoHttpLoader,
});
